import { SVGProps } from 'react';

export const ClearFilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.35398 2H1.99998C1.82089 2 1.66665 2.10476 1.58331 2.26190C1.49998 2.41905 1.51665 2.60952 1.62498 2.75238L5.49998 7.16667V13.3333C5.49998 13.7015 5.79855 14 6.16665 14H7.83331C8.20141 14 8.49998 13.7015 8.49998 13.3333V7.16667L9.17498 6.38095"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 2.33325L14.3333 5.66659"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3333 2.33325L11 5.66659"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
